import type { DataUpload } from '@/common/data-upload';
import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type AddDataUploadSuccessResponse = DataUpload;

export async function addDataUpload(dataUpload: Omit<DataUpload, 'id'>): Promise<AddDataUploadSuccessResponse | null> {
	const response = await axios.post(`${API_URLS.DATA_UPLOAD.INDEX}`, dataUpload);
	return getResponse<AddDataUploadSuccessResponse>(response.data);
}
